import styled from '@emotion/styled'

export const getInitial = (name: string): string | null => {
  const words = name.replace(/[!@#$%^&*_.()]/g, '').split(' ')
  if (words.length === 1) {
    const oneWords = words[0].split('-')
    if (oneWords.length > 1) {
      return oneWords.map((value: string) => value.charAt(0)).join('')
    }
    return words[0].slice(0, 2)
  }
  return words
    .slice(0, 2)
    .map((value: string) => value.charAt(0))
    .join('')
}

export const AuthorNameStyle = styled.span`
  overflow: hidden;
  color: #252525;
  font-variant-numeric: lining-nums proportional-nums;
  text-overflow: ellipsis;
  /* Body/B2 - Fira - Medium */
  font-family: Fira Sans, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 142.857% */
`
